// Internal function that returns an efficient (for current engines) version
// of the passed-in callback, to be repeatedly applied in other Underscore
// functions.
export default function optimizeCb(func, context, argCount) {
    if (context === void 0)
        return func;
    switch (argCount == null ? 3 : argCount) {
        case 1: return function (value) {
            return func.call(context, value);
        };
        // The 2-argument case is omitted because we’re not using it.
        case 3: return function (value, index, collection) {
            return func.call(context, value, index, collection);
        };
        case 4: return function (accumulator, value, index, collection) {
            return func.call(context, accumulator, value, index, collection);
        };
    }
    return function () {
        return func.apply(context, arguments);
    };
}
